import { Button } from "@mui/material";
import React from 'react';
import { IconButton } from '@mui/material';
import { AiFillEdit, AiOutlineDelete } from 'react-icons/ai';
const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
});

export const produceMillTransactionGrid = [
    { field: 'id', headerName: '#', width: 70, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'inv', headerName: 'Numri i Fletës', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'date', headerName: 'Data', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'client', headerName: 'Përshkrimi', width: 500, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'total', headerName: 'Vlera', type: 'string', width: 256, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

export const gridHeader = [
    { field: 'id', headerName: '#', width: 75, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'name', headerName: 'Emertimi', width: 500, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'unit', headerName: 'Njesia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'qty', headerName: 'Sasia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
]



export const ArticleReceptureDetails = [
    { field: 'id', headerName: '#', width: 76, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'recepture', headerName: 'Produktet e prodhuara', width: 600, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'qty', headerName: 'Sasia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'price', headerName: 'Cmimi Blerjes', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'value', headerName: 'Vlera', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    }
]

export const ProduceArticle = ({ changeButtons }) => [
    { field: 'id', headerName: '#', width: 86, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'recepture', headerName: 'Lenda e parë', width: 500, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'qty', headerName: 'Sasia', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'price', headerName: 'Cmimi Blerjes', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'value', headerName: 'Vlera', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'edit',
        headerName: 'Veprimet',
        width: 90,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (
            <IconButton
                // variant="contained"
                color="primary"
                size="small"
                onClick={() => changeButtons()}
            >
                <AiFillEdit style={{ color: "black", fontSize: "25px" }} />
            </IconButton>
        )
    }
]